export default __webpack_public_path__ + "static/media/send-invite-ticker.85413fc2.svg";